import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=50904cbd"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50904cbd')) {
      api.createRecord('50904cbd', component.options)
    } else {
      api.reload('50904cbd', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=50904cbd", function () {
      api.rerender('50904cbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuItemSelect/Table.vue"
export default component.exports